namespace appn.notifications {
    /**
     * Wait 5 secs on page load (after the first time this is called) instead of running the aggressive intervals every time the page loads
     */
    export let notificationPoll: number = 5500;
    export let notificationTimer: any = null;

    /**
     * Shows the Notifications dialog
     * Must pass in the button that launches to get the url
     */
    export function showNotificationsDialog(launchBtn: JQuery<HTMLElement>) {
        const url = launchBtn.data('notifications-launch') as string;
        if (!url)
            return;

        appn.iframe.openModal({ url: url })
            .then(function($modal: any) {
                $modal.on('hidden.bs.modal', function() {
                    updateNotificationTotal();
                });
            });
    }

    /**
     * Handles notifications updates
     * @param isBackingOff
     */
    export function updateNotificationTotal(isBackingOff?: boolean) {
        const notificationETag = window.localStorage.getItem('notificationETag');

        // ensure notifications launch is hooked ahead of any changes that may happen from update
        ensureClickHandler();

        appn.ajax.post({
            url: appn.urls.notifications.total,
            data: { etag: notificationETag },
            dataType: 'json',
            done: function(data: any) {
                const notificationETag = data.ETagSafe;
                window.localStorage.setItem('notificationETag', notificationETag);

                const $noticeDiv = $('.nav-notification');
                const $noticeDot = $('.noticeDot');

                if (data.Total === 0) {
                    $noticeDiv.hide();
                    $noticeDot.hide();
                    return;
                }
                $noticeDot.show();
                $noticeDiv.show();
                const $noticeBell = $('.notice-bell');

                // Bell/Alert color
                let css = 'info';
                if (data.HasError)
                    css = 'danger';
                else if (data.HasReady || data.HasComplete)
                    css = 'success';
                else if (data.HasInProgress)
                    css = 'purple';
                else if (data.HasPending)
                    css = 'warning';
                else if (data.HasInformation)
                    css = 'info';

                $noticeBell
                    .removeClass('fa-duotone-brand-info')
                    .removeClass('fa-duotone-brand-danger')
                    .removeClass('fa-duotone-brand-success')
                    .removeClass('fa-duotone-brand-warning')
                    .removeClass('fa-duotone-brand-purple')
                    .addClass('fa-duotone-brand-' + css);

                $noticeDot
                    .removeClass('bg-info')
                    .removeClass('bg-danger')
                    .removeClass('bg-success')
                    .removeClass('bg-warning')
                    .removeClass('bg-purple')
                    .addClass('bg-' + css);

                if (data.SuccessCount > 0)
                    $('.notice-badge.badge-success').text(data.SuccessCount).fadeIn();
                else
                    $('.notice-badge.badge-success').text('0').css('display', 'none');

                if (data.InfoCount > 0)
                    $('.notice-badge.badge-info').text(data.InfoCount).fadeIn();
                else
                    $('.notice-badge.badge-info').text('0').css('display', 'none');

                if (data.InProgressCount > 0)
                    $('.notice-badge.badge-purple').text(data.InProgressCount).fadeIn();
                else
                    $('.notice-badge.badge-purple').text('0').css('display', 'none');

                // Warnings and Information both display in the bottom left.
                if (data.PendingCount > 0 && data.InProgressCount === 0)
                    $('.notice-badge.badge-warning').text(data.PendingCount).fadeIn();
                else
                    $('.notice-badge.badge-warning').text('0').css('display', 'none');

                if (data.ErrorCount > 0)
                    $('.notice-badge.badge-danger').text(data.ErrorCount).fadeIn();
                else
                    $('.notice-badge.badge-danger').text('0').css('display', 'none');

                // Animate Bell and Badges if new
                if (data.HasNew)
                    setTimeout(function() {

                        // Animate the ringing bell and heartbeat the mini badge icons
                        $noticeBell.removeClass('shake-lr');
                        $noticeDiv.find('.notice-badge-mini').removeClass('heartbeat');
                        setTimeout(function() {
                            $noticeBell.addClass('shake-lr');
                            $noticeDiv.find('.notice-badge-mini').addClass('heartbeat');
                        }, 100);

                        if (data.DownloadLink)
                            appn.toast.notify('success', `Your Download is Ready. <a href="${data.DownloadLink}" target="_blank">Click here to Download</button>`);
                        
                    }, 1000); // Wait 1 secs to do the animation so there is a gap between browser load and animation

                if (notificationTimer !== null)
                    window.clearTimeout(notificationTimer);

                if (isBackingOff)
                    // Standard delay of timeout loop
                    notificationPoll += notificationPoll < 7000 ? 1500 : 10000; // Back off by 1.5 secs if total is less than 7 secs otherwise set harder back off of 10 secs.
                else
                    // If the update wasnt called by the timeout loop then must have been called from a new export - we must restart the aggressive calls so the bell is the right color and the available download pops
                    notificationPoll = 1500; // Check in another one and a half secs because a new export has just been scheduled

                notificationTimer = setTimeout(function() {
                    updateNotificationTotal(true); // Sending true here to identify if update was called by a new notification or is just in the standard timout loop loop.
                }, notificationPoll);

                ensureClickHandler();
            },
            fail: function() {
                $('.nav-notification').hide();
            }
        });
    }

    /**
     * Hides the notification icon in the side menu
     */
    export function hideNotificationIcon() {
        const $noticeDiv = $('.nav-notification');
        $noticeDiv.hide();
        if (notificationTimer !== null)
            window.clearTimeout(notificationTimer);
    }

    export function deleteNotificationsCsv(itemIdsCsv: string, onAlwaysCallback: Function) {
        appn.ajax.post({
            url: appn.urls.notifications.delete,
            data: { itemIdsCsv: itemIdsCsv },
            always: function() {
                updateNotificationTotal(true);
                if (onAlwaysCallback)
                    onAlwaysCallback();
            }
        });
    }

    export function rescheduleNotificationsCsv(itemIdsCsv: string, onAlwaysCallback: Function) {
        appn.ajax.post({
            url: appn.urls.notifications.reschedule,
            data: { itemIdsCsv: itemIdsCsv },
            always: function() {
                updateNotificationTotal(true);
                if (onAlwaysCallback)
                    onAlwaysCallback();
            }
        });
    }

    function ensureClickHandler() {
        // Auto click the boxes collapse/expand event when the title is clicked
        $('[data-notifications-launch]').off().on('click', function(event: Event) { 
            event.preventDefault();
            showNotificationsDialog($(this));
        });
    }
}
